/**
 * APP 关闭当前页面
 */
import { BridgeType, callGrowthMSIBridge, callKNBBridge, callMSIBridge, getBridgeType } from "./base";

/* ----- MSI.closePage 类型声明 start ----- */
// https://msi-extend.sankuai.com/api?tab=container&id=3133
/* ----- MSI.closePage 类型声明 end ----- */

/* ----- KNB.closePage 类型声明 start ----- */
// https://km.sankuai.com/collabpage/418124165
/* ----- KNB.closePage 类型声明 end ----- */

/* ----- GrowthMSI.navigateBack 类型声明 start ----- */
// https://km.sankuai.com/collabpage/2361354543
// https://km.sankuai.com/collabpage/2553249340
interface GrowthMSINavigateBackProps {
  delta?: number; // 返回的页面数量，默认值为 1，如果 delta 大于现有的页面数量，则返回到外投容器首页。若当前页面为唯一的页面，则无法返回，并抛出异常。
  disableExitConfirm?: boolean; // 是否忽略退出时二次确认，默认值为 false。
}
/* ----- GrowthMSI.navigateBack 类型声明 end ----- */

const bridgeType = getBridgeType();
export default function closePage() {
  switch (bridgeType) {
    case BridgeType.KNB:
      callKNBBridge('closePage');
      break;
    case BridgeType.MSI:
      callMSIBridge("closePage");
      break;
    case BridgeType.GROWTH_MSI:
      callGrowthMSIBridge("navigateBack", {
        disableExitConfirm: true,
      } as GrowthMSINavigateBackProps);
      break;
    default:
      break;
  }
}
